import React, { useEffect, useState } from "react"
import { Animated, Text, View } from "react-native";
import { useCssStyle } from "../../customHook/getCssStyle";
import { CustomModal } from "../customModal";


export const ProgressBarModal = ({ progressPercentage, heading }) => {


    const getStyles = useCssStyle();
    const progressAnimation = useState(new Animated.Value(0))[0];

    // Interpolation for width and color
    const progressInterpolate = progressAnimation.interpolate({
        inputRange: [0, 100],
        outputRange: ["0%", "100%"],
        extrapolate: "clamp"
    });

    const colorInterpolate = progressAnimation.interpolate({
        inputRange: getStyles(['colorInterpolateProgressBar']).inputRange,
        outputRange: getStyles(['colorInterpolateProgressBar']).outputRange
    });

    const progressStyle = {
        width: progressInterpolate,
        backgroundColor: colorInterpolate
    };


    useEffect(() => {

        Animated.timing(progressAnimation, {
            toValue: progressPercentage,
            duration: 1000,
            useNativeDriver: false // Required for interpolations that affect layout
        }).start();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [progressPercentage]);


    return (
        <CustomModal>
            <View style={getStyles(['progressBarModalContainer'])}>
                {heading && <Text style={getStyles(['progressBarContainer_title'])}>{heading}</Text>}

                <View style={getStyles(['progressBarContainer'])} >

                    <View style={getStyles(['progressBar'])}>
                        <View style={getStyles(['progressBarInnerContainer'])}>
                            <Animated.View style={[getStyles(['progressBarAnimateContainer']), progressStyle]}></Animated.View>
                        </View>
                    </View>
                </View>
            </View>
        </CustomModal>
    )
}